import _ from 'lodash'

export default class RuleHelper {
  public static required = (value: any) => {
    return !(value === '' || _.isUndefined(value) || _.isNil(value)) || 'กรุณากรอกข้อมูล'
  }
  public static number = (value: any) => {
    const regExp = new RegExp(/^[0-9]+$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'กรุณากรอกจำนวนเต็มบวก'
  }
  public static phone = (value: any) => {
    const regExp = new RegExp(/^(0)[1-9]{1}[0-9]{7,8}$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'หมายเลขโทรศัพท์จะต้องเริ่มด้วย 0, จากนั้นตามด้วยเลข 8-9 ตัว'
  }
  public static currency = (value: any) => {
    const regExp = new RegExp(/^[0-9]{1,}([.][0-9]{1,}){0,1}$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'กรุณากรอกราคาให้ถูกต้อง'
  }
  public static percent = (value: any) => {
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && value <= 100)) || 'กรุณากรอกค่าไม่เกิน 100'
  }
  public static date = (value: any) => {
    const regExp = new RegExp(/^[0-9]{2}(\/){1}[0-9]{2}(\/){1}(2)[5][6,9]{1}[0-9]{1}$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'กรุณากรอกวันที่ให้ถูกต้อง'
  }
  public static time = (value: any) => {
    const regExp = new RegExp(/^[0-9]{2}(:)[0-9]{2}$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'กรุณากรอกเวลาให้ถูกต้อง'
  }
  public static tempurature = (value: any) => {
    const regExp = new RegExp(/^[1-9][0-9]{1}([.][0-9]{1,2}){0,1}$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'กรุณากรอกอุณหภูมิให้ถูกต้อง เช่น 37.5'
  }
  public static bloodPressure = (value: any) => {
    const regExp = new RegExp(/^[1-9]{0,2}[0-9]{1}(\/)[1-9]{0,2}[0-9]{1}$/)
    return (_.isNull(value) || _.isEmpty(value) || (!(_.isEmpty(value) || _.isNull(value)) && regExp.test(value))) || 'กรุณากรอกความดันให้ถูกต้อง เช่น 120/80'
  }
}
